import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../Button";

const Model = ({ isOpen, onClose, children, name }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 ">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
              className="w-full max-w-3xl max-h-[92vh] bg-white border-2 border-gray-900 flex flex-col rounded-none "
          >
            <div className="sticky top-0 z-10 bg-white border-b border-gray-100 px-8 py-5 flex justify-between items-center shrink-0">
              <div className="flex flex-col">
                <h2 className="text-[14px] font-black text-gray-800 uppercase tracking-[3px]">
                  {name}
                </h2>
                <div className="w-12 h-1 bg-[#3F80F7] mt-1 flex"></div>
              </div>
              <button
                onClick={onClose}
                className="hover:bg-gray-50 p-2 transition-all border border-gray-100/50 hover:border-gray-200"
              >
                <IoClose size={20} className="text-gray-400 group-hover:text-[#3F80F7]" />
              </button>
            </div>

            <div className="overflow-y-auto flex-1 px-5 py-5 bg-[#f8fafc]">
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>

  );
};

export default Model;
